import React from 'react'
import { checkoutHooks } from '@pff-consumer/data-provider/lib/checkout/checkout.hooks'
import { SubscriptionLayout } from '@pff-consumer/feature-account/components/subscription-layout/subscription-layout.web'
import { useStyles } from './subscription.styles'
import { PffInsights } from '../common/pff-insights/pff-insights'

const { useBreakpoints, useGetIsLoggedIn } = checkoutHooks

export const Subscription = () => {
  const { isDesktop } = useBreakpoints()
  const styles = useStyles()
  const isLoggedIn = useGetIsLoggedIn()

  return (
    <>
      {!isDesktop && <PffInsights />}
      <SubscriptionLayout />
      {!isLoggedIn && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        // eslint-disable-next-line @next/next/no-html-link-for-pages
        <a
          href='/login'
          className={styles.loginLink}
          data-analytics-id='existing-account-login-link'
        >
          Already have an account? Log In
        </a>
      )}
    </>
  )
}
